import React from 'react';
import { Button, LightHeader } from 'components';

import './onboardingContainer.scss'

export default class OnboardingContainer extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    return ( 
      <div>
        <LightHeader />
        <div className="onboarding">
          <div className="onboarding__header-container">
            <h2 className="onboarding__header">Welcome, start improving your SEO today</h2>
            <h4 className="onboarding__subheader">Please select a plan:</h4>
          </div>
          <div className="onboarding__plan-container">
            <div className="onboarding__plan-option-container">
              <h2>Free</h2>
              <h4 className="medium-spacing2--top">Free forever, $0/month</h4>
              <ul className='icon-font-list large-spacing'>
                <li className='icon-font-list__list-item icon-font-list__list-item--check'>Unlimited SEO, Blog, Speed problems checks</li>
                <li className='icon-font-list__list-item icon-font-list__list-item--check'>Fix instructions & code</li>
                <li className='icon-font-list__list-item icon-font-list__list-item--check'>Automatic email alerts</li>
                <li className='icon-font-list__list-item icon-font-list__list-item--check'>Email help & support</li>
                <li className="onboarding__plan-detail-spacing"></li>
              </ul>
              <Button 
                label="Get Started"
                 buttonType="primary"
              />
            </div>
            <div className="onboarding__plan-option-container">
              <h2>Plus</h2>
              <h4 className="medium-spacing2--top">14 Day Free Trial, then $20/month</h4>
              <ul className='icon-font-list large-spacing'>
                <li className='icon-font-list__list-item icon-font-list__list-item--check'>Improve the SEO of your shop straight away</li>
                <li className='icon-font-list__list-item icon-font-list__list-item--check'>Get powerful tools to manage your SEO</li>
                <li className='icon-font-list__list-item icon-font-list__list-item--check'>Free installation and premium support</li>
                <li className='icon-font-list__list-item icon-font-list__list-item--check'>Video tutorials, detailed help docs</li>
                <li className='icon-font-list__list-item icon-font-list__list-item--check'>Downgrade to the free version at any time</li>
              </ul>
              <Button 
                label="Start 7-day trial"
                buttonType="primary"
              />
            </div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./app/containers/OnboardingContainer.js